import React, { useEffect, useState } from "react";
import ApiService from "../../../services/ApiService";
import { callAlert } from "../../../services/CommonService";
import Chart from "react-apexcharts";
import GuageWidget from "../../../components/Common/Guage";
import Loader from "../../../features/Loader";

function GradeBook(props) {
  const { outputChange } = props;
  const [data, setData] = useState([]);
  const [gradbookDropdown, setGradbookDropdown] = useState([]);
  const [quizProgress, setQuizProgress] = useState([]);
  const [assignmentProgressReport, setAssignmentProgressReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingGuage, setLoadingGuage] = useState(true);
  const [loaderquizProgress, setLoaderquizProgress] = useState(true);
  const [loaderassProgress, setLoaderassProgress] = useState(true);
  const [optionsGrade, setOptionsGrade] = useState({});
  const [selectCourseType, setSelectCourseType] = useState("");
  const [optionsQuiz, setOptionsQuiz] = useState({});
  const [quizSummary, setQuizSummary] = useState([]);

  useEffect(() => {
    if (loading) {
      loadGradbookDropdown();
      loadChart();
      changeCourseType();
    }
  }, []);

  const loadGradbookDropdown = () => {
    ApiService.publicGetRequest("/subscription/subcription-drop-down", true)
      .then((res) => {
        if (res.data?.resultCode == 1) {
          setGradbookDropdown(res.data.data ? res.data.data : []);
          setLoading(false);
        } else {
          callAlert("", res?.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoading(false);
      });
  };

  const loadChart = () => {
    ApiService.publicGetRequest("/progress/overallProgressSummary", true)
      .then((res) => {
        if (res.data?.resultCode == 1) {
          let newData = {};
          if (res.data?.data) {
            newData = res.data.data;

            newData["quiz"] = newData["quiz"].toFixed(2);
            newData["assignment"] = newData["assignment"].toFixed(2);
            newData["all"] = newData["all"].toFixed(2);
          }
          setData(newData);
          setLoadingGuage(false);
        } else {
          callAlert("", res?.message);
          setLoadingGuage(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoadingGuage(false);
      });
  };

  const changeDropdown = (e) => {
    changeCourseType(e);
  };

  const changeCourseType = (v = "") => {
    if (v) {
      v = `?courseName=${v}`;
    }

    setLoaderassProgress(true);
    setLoaderquizProgress(true);

    ApiService.publicGetRequest("/progress/quizProgress" + v, true)
      .then((res) => {
        if (res.data?.resultCode == 1) {
          let newData = [];
          let categories = [];

          if (res.data?.data.length > 0) {
            if (v) {
              res.data?.data.forEach((d) => {
                newData.push(d.score);
                categories.push(d.quizName);
              });
            } else {
              function groupByKey(array, key) {
                return array.reduce((hash, obj) => {
                  if (obj[key] === undefined) return hash;
                  return Object.assign(hash, {
                    [obj[key]]: (hash[obj[key]] || []).concat(obj),
                  });
                }, {});
              }

              let courseName = groupByKey(res.data?.data, "courseName");

              for (const [key, value] of Object.entries(courseName)) {
                let score = 0;
                let count = 0;
                let perc = 0;
                value.forEach((d) => {
                  score = score + d.score;
                  count++;
                });

                perc = (score * 100) / (count * 100);

                newData.push(perc);
                categories.push(key);
              }
            }
          }

          setQuizProgress({
            name: "series-1",
            data: newData,
          });

          setOptionsQuiz({
            chart: {
              id: "apexchart-example",
              toolbar: {
                show: false,
              },
            },
            yaxis: {
              min: 0,
              max: 100,
              show: true,
              title: {
                text: "Score " + (v ? "" : "%"),
                style: {
                  fontSize: "12px",
                  fontWeight: 500,
                },
              },
            },
            xaxis: {
              show: true,
              categories: categories,
              title: {
                text: v ? "Quizzes" : "Courses",
                style: {
                  fontSize: "12px",
                  fontWeight: 500,
                },
              },
            },
            title: {
              text: "",
              align: "left",
              margin: 10,
              offsetX: 0,
              offsetY: 0,
            },
            dataLabels: {
              enabled: true,
              style: {
                fontSize: "9px",
                fontFamily: "Helvetica, Arial, sans-serif",
              },
            },
          });

          setLoaderquizProgress(false);
        } else {
          callAlert("", res?.message);
          setLoaderquizProgress(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoaderquizProgress(false);
      });

    ApiService.publicGetRequest("/progress/assignmentProgressReport" + v, true)
      .then((res) => {
        if (res.data?.resultCode == 1) {
          let perc = 0;
          let labels = "Grade ";
          if (res.data?.data.length > 0) {
            let score = 0;
            let count = 0;
            res.data?.data.forEach((d) => {
              score = score + d.score;
              count++;
            });
            perc = (score * 100) / (count * 100);
            perc = Number(perc.toFixed(2));
            labels += perc + "%"; //score+"/"+count*100;
          }

          setAssignmentProgressReport(perc);

          setOptionsGrade({
            chart: {
              height: 350,
              type: "radialBar",
            },
            plotOptions: {
              radialBar: {
                inverseOrder: false,
                startAngle: 0,
                endAngle: 360,
                offsetX: 0,
                offsetY: 0,
                hollow: {
                  margin: 4,
                  size: "70%",
                  background: "transparent",
                  image: undefined,
                  imageWidth: 150,
                  imageHeight: 150,
                  imageOffsetX: 0,
                  imageOffsetY: 0,
                  imageClipped: true,
                  position: "front",
                  dropShadow: {
                    enabled: false,
                    top: 0,
                    left: 0,
                    blur: 3,
                    opacity: 0.5,
                  },
                },
                track: {
                  show: true,
                  startAngle: undefined,
                  endAngle: undefined,
                  background: "#f2f2f2",
                  strokeWidth: "87%",
                  opacity: 1,
                  margin: 4,
                  dropShadow: {
                    enabled: false,
                    top: 0,
                    left: 0,
                    blur: 3,
                    opacity: 0.5,
                  },
                },
                dataLabels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: "14px",
                    fontFamily: undefined,
                    fontWeight: 600,
                    color: "#000000",
                    offsetY: 5,
                  },
                  value: {
                    show: false,
                    fontSize: "14px",
                    fontFamily: undefined,
                    fontWeight: 400,
                    color: undefined,
                    offsetY: 16,
                    formatter: function (val) {
                      return val + "%";
                    },
                  },
                  total: {
                    show: false,
                    label: "Total",
                    color: "#373d3f",
                    fontSize: "16px",
                    fontFamily: undefined,
                    fontWeight: 600,
                    formatter: function (w) {
                      const avg =
                        w.globals.seriesTotals.reduce((a, b) => a + b, 0) /
                        w.globals.series.length;

                      return avg.toFixed(2) + "%";
                    },
                  },
                },
                barLabels: {
                  enabled: false,
                  offsetX: 0,
                  offsetY: 0,
                  useSeriesColors: true,
                  fontFamily: undefined,
                  fontWeight: 600,
                  fontSize: "16px",
                  formatter: (val) => {
                    return val;
                  },
                  onClick: undefined,
                },
              },
            },

            fill: {
              colors: ["#05d48d"],
            },
            labels: [labels],
          });

          console.log(optionsGrade);

          setLoaderassProgress(false);
        } else {
          callAlert("", res?.message);
          setLoaderassProgress(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoaderassProgress(false);
      });
  };

  const loadQuizSummary = () => {
    setLoaderquizProgress(true);

    ApiService.publicGetRequest("/quiz/quiz-summary", true)
      .then((res) => {
        if (res.data?.resultCode === 1) {
          const rawData = res.data.data || [];

          // 👇 Transform data into grouped format
          const grouped = {};

          rawData.forEach((item) => {
            const course = item.courseName;

            if (!grouped[course]) {
              grouped[course] = {
                courseName: course,
                RETRY: 0,
                INPROGRESS: 0,
                COMPLETE: 0,
              };
            }

            if (item.status === "RETRY") {
              grouped[course].RETRY += 1;
            }

            if (item.status === "INPROGRESS") {
              grouped[course].INPROGRESS += 1;
            }

            if (item.status === "COMPLETE") {
              grouped[course].COMPLETE += 1;
            }
          });

          setQuizSummary(Object.values(grouped));
          setLoaderquizProgress(false);
        } else {
          callAlert("", res?.data?.message);
          setLoaderquizProgress(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.message);
        setLoaderquizProgress(false);
      });
  };

  useEffect(() => {
    loadQuizSummary();
  }, []);

  return (
    <div>
      <span className="overallGrade mb-3">Overall Grade</span>

      <br></br>

      <h4 className="title4 ms-2"> Completion of Modules Your Grade</h4>

      <div className="row mt-2">
        <div className="col-md-12">
          <div className="bg-grey p-2 mb-3">
            <div className="row">
              <div className="col-md-4">
                <div className="bg-white p-3 border">
                  <h4 className="title4">Overall Score</h4>
                  {loadingGuage ?
                    <Loader />
                  : <GuageWidget score={data.all} color="#366598" />}
                </div>
              </div>
              <div className="col-md-4">
                <div className="bg-white p-3 border">
                  <h4 className="title4">Quiz Scores</h4>

                  {loadingGuage ?
                    <Loader />
                  : <GuageWidget score={data.quiz} color="#f7b024" />}
                </div>
              </div>

              <div className="col-md-4">
                <div className="bg-white p-3 border">
                  <h4 className="title4">Coding Assignment Score</h4>
                  {loadingGuage ?
                    <Loader />
                  : <GuageWidget score={data.assignment} color="#fd5151" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loading && (
        <>
          {/* <select
            value={selectCourseType}
            className="w-25 p-2 border mb-3 rounded-1 "
            onChange={async (e) => {
              setSelectCourseType(e.currentTarget.value);
              changeDropdown(e.currentTarget.value);
            }}
          >
            <option value="">Select Course</option>
            {gradbookDropdown &&
              gradbookDropdown.map((d) => (
                <option key={d.courseId} value={d.courseName}>
                  {d.courseName}
                </option>
              ))}
          </select> */}

          <div className="row">
            {/* <div className="col-md-7">
              <div className="border p-3">
                <div className="d-flex justify-content-between">
                  <h4 className="title4">Graph Analysis - Quiz</h4>
                  <button className="btn btn-primary" onClick={() => outputChange("quizReport")}>
                    Show all quiz report
                  </button>
                </div>
                {loaderquizProgress ? (
                  <Loader />
                ) : (
                  <Chart
                    options={optionsQuiz}
                    series={[quizProgress]}
                    type="bar"
                    width={400}
                    height={320}
                  />
                )}
              </div>
            </div> */}

            <div className="col-md-7">
              <div className="border p-">
                <div className="d-flex justify-content-between p-3">
                  <h4 className="title4 mt-2">Graph Analysis - Quiz</h4>
                  <button
                    className="btn btn-primary"
                    onClick={() => outputChange("quizReport")}
                  >
                    Show all quiz report
                  </button>
                </div>

                {loaderquizProgress ?
                  <Loader />
                : <div
                    className="table-responsive "
                    style={{
                      height: "300px", // personalized height
                      overflowY: "auto",
                      // borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <table
                      className="table table-hover table-sm mb-0"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          background: "#f8f9fc",
                          boxShadow: "0 1px 0 rgba(0,0,0,0.05)",
                        }}
                      >
                        <tr>
                          <th
                            className="text-start"
                            style={{
                              padding: "10px 12px",
                              borderBottom: "none",
                            }}
                          >
                            Course Name
                          </th>
                          <th
                            className="text-center"
                            style={{
                              padding: "10px 7px",
                              borderBottom: "none",
                            }}
                          >
                            Retry
                          </th>
                          <th
                            className="text-center"
                            style={{
                              padding: "10px 7px",
                              borderBottom: "none",
                              // whiteSpace: "nowrap",
                            }}
                          >
                            In Progress
                          </th>

                          <th
                            className="text-center"
                            style={{
                              padding: "10px 7px",
                              borderBottom: "none",
                            }}
                          >
                            Completed
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {quizSummary && quizSummary.length > 0 ?
                          quizSummary.map((row, index) => (
                            <tr
                              key={index}
                              style={{
                                borderBottom: "1px solid #f1f1f1",
                              }}
                            >
                              <td style={{ padding: "10px 12px" }}>
                                <div style={{ fontWeight: 600 }}>
                                  {row.courseName}
                                </div>
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px 7px" }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    minWidth: "32px",
                                    padding: "2px 6px",
                                    borderRadius: "999px",
                                    background: "rgba(220,53,69,0.08)",
                                    color: "#dc3545",
                                    fontWeight: 600,
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {row.RETRY}
                                </span>
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px 7px" }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    minWidth: "32px",
                                    padding: "2px 6px",
                                    borderRadius: "999px",
                                    background: "rgba(255,193,7,0.12)",
                                    color: "#ffc107",
                                    fontWeight: 600,
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {row.INPROGRESS}
                                </span>
                              </td>
                              <td
                                className="text-center"
                                style={{ padding: "10px 7px" }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    minWidth: "32px",
                                    padding: "2px 6px",
                                    borderRadius: "999px",
                                    background: "rgba(25,135,84,0.12)",
                                    color: "#198754",
                                    fontWeight: 600,
                                    fontSize: "0.8rem",
                                  }}
                                >
                                  {row.COMPLETE}
                                </span>
                              </td>
                            </tr>
                          ))
                        : <tr>
                            <td
                              colSpan="4"
                              className="text-center"
                              style={{
                                padding: "16px 12px",
                                color: "#6c757d",
                              }}
                            >
                              No Data Available
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            </div>

            <div className="col-md-5 text-center">
              <div className="border p-3">
                <h4 className="title4 text-start">
                  Coding assignment feedback
                </h4>

                {loaderassProgress ?
                  <Loader />
                : <Chart
                    options={optionsGrade}
                    series={[assignmentProgressReport]}
                    type="radialBar"
                    height={350}
                  />
                }

                <strong
                  className="f16 mb-2 mt-3"
                  style={{ color: "#05d48d", fontSize: "16px" }}
                >
                  {" "}
                  Great methodology{" "}
                </strong>
                <div className="mb-4">
                  <strong> Teacher Feedback</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5 mb-4 ">
            <div className="col-md-8 offset-md-2 text-center">
              <strong>
                View your strengths & personalized improvement suggestions ,
                click the links below to access detailed analysis{" "}
              </strong>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6 ">
              <button
                className="btn btn-primary btn-primary4 float-end f12"
                onClick={() => outputChange("improvement-suggestions")}
              >
                Your Strength
              </button>
            </div>
            <div className="col-md-6">
              <button
                className="btn btn-primary  btn-primary4 f12"
                onClick={() => outputChange("improvement-suggestions")}
              >
                Improvement Suggestions{" "}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default GradeBook;
